import React from 'react';
import { FaFacebook, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // Social media links
  const socialLinks = [
    { icon: <FaFacebook className="text-xl" />, url: "https://www.facebook.com/profile.php?id=61575573322605" },
    { icon: <FaYoutube className="text-xl" />, url: "https://www.youtube.com/@unnatkhetiofficial" },
  ];

  // Quick links
  const quickLinks = [
    { name: "Home", url: "/" },
    { name: "About Us", url: "/About" },
    { name: "Service", url: "/Services" },
    { name: "Product", url: "/Products" },
    { name: "Blog", url: "/Blog" }
  ];

  return (
    <footer className="relative bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-800 text-white pt-16 pb-8 px-4 sm:px-6 lg:px-8">
      {/* Wave Animation */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none transform rotate-180">
        <svg 
          className="relative block w-[calc(100%+1.3px)] h-16" 
          viewBox="0 0 1200 120" 
          preserveAspectRatio="none"
        >
          <path 
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" 
            className="fill-current text-white opacity-20"
          ></path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-yellow-300">
              UnnatKheti
            </h3>
            <p className="text-gray-300">
              Farming Made Smarter, Life Made Better.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((link, index) => (
                <a 
                  key={index}
                  href={link.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-all duration-300 transform hover:-translate-y-1 hover:scale-110"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 border-b border-pink-500 pb-2 inline-block">
              Quick links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.url} 
                    className="text-gray-300 hover:text-white transition-colors duration-300 hover:pl-2 hover:border-l-4 hover:border-pink-500 block"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 border-b border-pink-500 pb-2 inline-block">
              Contact Us
            </h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start">
                <svg className="w-5 h-5 mr-2 mt-1 text-pink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                {/* Clickable Mobile Number */}
                <a href="tel:+919234041819" className="hover:text-white hover:underline transition-colors duration-300">
                  +91 9234041819
                </a>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 mr-2 mt-1 text-pink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                {/* Clickable Email */}
                <a href="mailto:info@pcds.co.in" className="hover:text-white hover:underline transition-colors duration-300">
                  info@pcds.co.in
                </a>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 mr-2 mt-1 text-pink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span>1st Floor Mukta Tawar,Near Andheri Station, <br />Mumbai - 400058</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold mb-4 border-b border-pink-500 pb-2 inline-block">
              Newsletter
            </h4>
            <p className="text-gray-300 mb-4">
              Subscribe to our newsletter for latest updates and offers.
            </p>
            <form 
              onSubmit={async (e) => {
                e.preventDefault();
                const emailInput = e.target.elements.email;
                const email = emailInput.value.trim();
                const messageEl = e.target.querySelector('.response-msg');

                if (!/\S+@\S+\.\S+/.test(email)) {
                  messageEl.textContent = "Please enter a valid email address.";
                  messageEl.className = "response-msg text-sm mt-1 text-yellow-300 font-medium";
                  return;
                }

                const data = new URLSearchParams();
                data.append("email", email);

                try {
                  const res = await fetch("https://script.google.com/macros/s/AKfycbyP6iq2CCUipVTJts_PH1iIPo0MgsIuRnro9Oj-pJmwRBc9i6frx4dz7vbmb-shiFx8Cg/exec", {
                    method: "POST",
                    body: data,
                  });

                  const text = await res.text();
                  if (text.includes("Success")) {
                    messageEl.textContent = "Thank you for subscribing!";
                    messageEl.className = "response-msg text-sm mt-1 text-green-300 font-medium";
                    emailInput.value = "";
                  } else {
                    messageEl.textContent = "Subscription failed. Please try again.";
                    messageEl.className = "response-msg text-sm mt-1 text-pink-300 font-medium";
                  }
                } catch (err) {
                  messageEl.textContent = "Network error. Please check your connection.";
                  messageEl.className = "response-msg text-sm mt-1 text-pink-300 font-medium";
                }
              }}
              className="flex flex-col space-y-3"
            >
              <input 
                type="email" 
                name="email"
                placeholder="Your email" 
                className="px-4 py-2 rounded-md bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300"
                required
              />
              <button 
                type="submit"
                className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-md text-white font-medium hover:from-pink-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-opacity-50 shadow-lg hover:shadow-xl"
              >
                Subscribe
              </button>
              <p className="response-msg text-sm mt-1"></p>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p className="flex items-center justify-center">
            &copy; {currentYear} UnnatKheti. All rights reserved. 
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;